import { aiFirstCreationStreamingState } from '@databases/database-ai-first-creation-state';
import { useDatabaseStreamState } from '@databases/database-ai-first-creation-ui';
import { getService } from '@databases/service-container';
import { useEffect, useRef } from 'react';
import { useSnapshot } from 'valtio';

export const useDeselectOnStreaming = (isStreaming: boolean): void => {
  const selectionsActions = getService('SelectionsActions');
  const { operationType } = useDatabaseStreamState();
  const { currentFieldOperation, currentEntryOperation } = useSnapshot(
    aiFirstCreationStreamingState
  );
  const hasDeselected = useRef(false);

  useEffect(() => {
    if (!isStreaming) {
      hasDeselected.current = false;
      return;
    }

    const isDeletingField =
      operationType === 'edit' && currentFieldOperation === 'delete';
    const isDeletingEntry =
      operationType === 'edit' && currentEntryOperation === 'delete';

    if (!hasDeselected.current && !isDeletingField && !isDeletingEntry) {
      selectionsActions.deselectAll();
      hasDeselected.current = true;
    }
  }, [
    selectionsActions,
    isStreaming,
    operationType,
    currentFieldOperation,
    currentEntryOperation,
  ]);
};
